import React from 'react';
import { Box, Typography } from '@mui/material';
import NaverMapWithList from './common/NaverMapWithList';

const Home = () => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        backgroundColor: '#F8F8FE',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* 상단 헤더 */}
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mb: 3
        }}
      >
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 600,
            color: '#3A3A3A'
          }}
        >
          홈 - 매장 위치 현황
        </Typography>
      </Box>

      {/* 네이버 지도 + 리스트 영역 */}
      <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <NaverMapWithList />
      </Box>
    </Box>
  );
};

export default Home;
